<div class="overview-page-container">
  <h1>ÐÐ±Ð·Ð¾Ñ</h1>

  <div *ngIf="settingsShow" id="settings">
    <h3>ÐÐ¾Ð»ÑÑÐ¸ÑÐµ Ð´Ð¾ÑÑÑÐ¿ Ðº Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐµ ÑÑÐ»ÑÐ³</h3>
    <text>ÐÐºÐ»ÑÑÐ¸ÑÐµ API, ÑÑÐ¾Ð±Ñ ÑÐ°Ð±Ð¾ÑÐ°ÑÑ Ñ ÐºÐ¾Ð¼Ð¼ÐµÑÑÐ¸ÑÐºÐ¸Ð¼Ð¸ ÑÑÐ»ÑÐ³Ð°Ð¼Ð¸, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð²Ñ Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑÐµ Ð¶Ð¸ÑÐµÐ»ÑÐ¼ Ð´Ð¾Ð¼Ð¾Ð²</text>
    <span routerLink="/management-company/settings">ÐÐµÑÐµÐ¹ÑÐ¸ Ð² Â«ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¸ APIÂ»</span>

    <div id="close-settings" (click)="settingsShow = !settingsShow"></div>
  </div>

  <arm-wizard></arm-wizard>

  <h2>ÐÐ¾Ð¼Ð° Ð½Ð° Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ð¸</h2>

  <arm-serviced-houses></arm-serviced-houses>

</div>
